import { Button, Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ButtonsMobile.css';

interface IButtonsMobileProps {
  onChangeFilters(): void;
  onResetFilters(): void;
  isFiltersLoading: boolean;
  isButtonsDisabled: boolean;
}

export const ButtonsMobile: React.FC<IButtonsMobileProps> = ({
  onChangeFilters,
  onResetFilters,
  isFiltersLoading,
  isButtonsDisabled,
}) => {
  return (
    <Responsive phone tablet>
      <div className={styles['container']}>
        <Button theme="fill_secondary" onClick={onResetFilters} size="L" fullWidth disabled={isButtonsDisabled}>
          Сбросить
        </Button>
        <Button
          theme="fill_primary"
          onClick={onChangeFilters}
          size="L"
          fullWidth
          disabled={isButtonsDisabled}
          loading={isFiltersLoading}
        >
          Применить
        </Button>
      </div>
    </Responsive>
  );
};
